import '@/styles/global.scss';
import '@/utils/register-hooks';
import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import { httpVuePlugin } from 'api-module';
import App from './App';



Vue.config.productionTip = false;
Vue.use(httpVuePlugin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
